import 'css-chunksrc/client/scenes/workloads/graph/elementsOverlay/element/milestone/styles.scss';export default {
  "milestone": "_milestone_1lmo1_1",
  "iconBox": "_iconBox_1lmo1_11",
  "icon": "_icon_1lmo1_11",
  "blocked": "_blocked_1lmo1_26"
};